export default __webpack_public_path__ + "static/media/wizzflix_logo.61a55edd.png";